<script setup>
import { createOrbEngine } from './orbEngine'

const props = defineProps({
  texture: { type: String, required: true },
  preload: { type: Array, default: () => [] },
  state: { type: String, default: 'idle' },
  outputAnalyser: { default: null },
  inputAnalyser: { default: null }
})

const canvasRef = ref(null)
const glFailed = ref(false)
const engineRef = ref(null)

onMounted(() => {
  const canvas = canvasRef.value
  if (!canvas) return
  const engine = createOrbEngine(canvas)
  if (!engine) {
    glFailed.value = true
    return
  }
  engineRef.value = engine
  if (props.preload?.length) engine.preload(props.preload)
  engine.setTexture(props.texture)
  engine.setState(props.state)
  engine.attachOutput(props.outputAnalyser)
  engine.attachInput(props.inputAnalyser)

  const onLost = (event) => event.preventDefault()
  const onRestored = () => {
    engine.destroy(false)
    const next = createOrbEngine(canvas)
    if (!next) return
    engineRef.value = next
    if (props.preload?.length) next.preload(props.preload)
    next.setTexture(props.texture)
    next.setState(props.state)
    next.attachOutput(props.outputAnalyser)
    next.attachInput(props.inputAnalyser)
  }
  canvas.addEventListener('webglcontextlost', onLost)
  canvas.addEventListener('webglcontextrestored', onRestored)
})

watch(() => props.texture, (url) => engineRef.value?.setTexture(url))
watch(() => props.preload, (urls) => urls?.length && engineRef.value?.preload(urls), { deep: true })
watch(() => props.state, (state) => engineRef.value?.setState(state))
watch(() => props.outputAnalyser, (analyser) => engineRef.value?.attachOutput(analyser))
watch(() => props.inputAnalyser, (analyser) => engineRef.value?.attachInput(analyser))

onBeforeUnmount(() => {
  engineRef.value?.destroy(true)
  engineRef.value = null
})

</script>

<template>
  <div
    v-if="glFailed"
    class="orb"
    :style="{ backgroundImage: `url(${texture})` }"
  />
  <canvas
    v-else
    ref="canvasRef"
    class="orb"
  />
</template>
